import { ReactElement } from 'react';
import styles from '@/styles/components/shade-loding.module.less';
import { useTranslation } from '@/services';
import TokenName from '../token/TokenName';
const TokenMintLoad = (props: SwapLoadData): ReactElement => {
    const { t } = useTranslation('common', 'shade');
    return (
        <div className={styles['mint']}>
            {t('mint.y-w-m')}&nbsp;
            <span>{props.tokenAddress ? <TokenName token={props.tokenAddress}></TokenName> : props.tokenSymbol}</span>
            &nbsp; {t('mint.amount')} <span>{props.token}</span> <br />
        </div>
    );
};

export default TokenMintLoad;
